export default __webpack_public_path__ + "static/media/REL-DIN-3PH.af4b4182.png";